var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fileIsTooBig)?_c('div',{staticClass:"file-viewer file-too-big"},[_vm._v(" "+_vm._s(_vm.$t('dragAndDropContainer.fileTooBigForPreview'))+" ")]):_c('div',{staticClass:"file-viewer"},[(_vm.file)?_c(_vm.getComponent,{tag:"component",attrs:{"documentId":_vm.uniqueDOMuid,"pdfFile":_vm.file,"imageFile":_vm.file}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }